import { FC } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { FilterIcon } from '../../../../../assets/svg/filter';
import { SortIcon } from '../../../../../assets/svg/sort';
import { Button } from '../../../../../components/button/button';
import { DropdownFilter } from '../../../../../features/dropdown-filter/dropdown-filter';
import { DropdownSorter } from '../../../../../features/dropdown-sorter/dropdown-sorter';
import { DropdownStyleView } from '../../../../../features/dropdown-style-view/dropdown-style-view';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { useTasksPlannerUtils } from '../use-task-planner-utils';
import s from './tasks-planner-controls.module.css';

interface Props {
  onCreateClick: () => void;
}

export const TasksPlannerControls: FC<Props> = ({ onCreateClick }) => {
  const { t, branches } = useTasksPlannerUtils();

  return (
    <div className={s.feature}>
      <DropdownStyleView />
      <DropdownSorter
        label={t('Сортировка')}
        leftIcon={<SortIcon />}
        options={[
          { label: t('Сначала новые'), value: 'created_at', dir: 'desc' },
          { label: t('Сначала старые'), value: 'created_at', dir: 'asc' },
        ]}
      />
      <DropdownFilter
        label={t('Фильтр')}
        leftIcon={<FilterIcon />}
        options={[
          {
            label: t('По ответственному'),
            value: 'employee',
            filter: 'input',
          },
          {
            label: t('По филиалу'),
            value: 'branch',
            filter: 'multi-select',
            filterOptions: branches,
          },
        ]}
      />

      <HasAccess service="task" permissions={['write']}>
        <Button
          size="lg"
          className={s.add}
          onClick={() => onCreateClick()}
          data-testid="add-task-button"
        >
          <AiOutlinePlus />
          {t('Запланировать')}
        </Button>
      </HasAccess>
    </div>
  );
};
